import {createContext} from 'react'

export const WindowContext = createContext(null)
